import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Selector } from '@components/design-system';
import { ICurrency } from '@interface/currency';
import { RootState } from '@state/store';

interface ISelectorCurrency {
  onChange: (nextValue: string) => void;
}

export const SelectorCurrency: FC<ISelectorCurrency> = ({ onChange }) => {
  const { currencies } = useSelector((state: RootState) => state.global);

  const temp = currencies.map((currency: ICurrency) => {
    return { value: currency.symbol, label: currency.name };
  });

  const list = temp.length > 0 ? temp : [{ value: 'XTZ', label: 'Tezos' }];

  return <Selector value={list[0].value} list={list} onChange={onChange} />;
};
